import React from 'react';
import accidentMap from './assets/img/map.webp';



export default function ReportDiagram({ locations }) {
  return(
    <div className="report-section">
      <h2>Structural Condition Map</h2>
      <p>Overview of signs of accidents detected on the vehicle</p>
      <div className="report-map">
        <div className="diagram-spacer" />
        <div className="diagram-column">
          <img className="report-map-img" src={accidentMap} alt="Mapping" />
          { locations.map((location, index) => (
            <div key={index} className="diagram-marker" style={{top:`${location.y*100}%`, left:`${location.x*100}%`}}/>
          ))}
        </div>
        <div className="diagram-spacer" />
        <div className="diagram-column">
          {(locations.length > 0) ? (
            <>
              <div className="diagram-marker" style={{top:'50%', left:'0%'}}/>
              <h3>Damage/Repair Indicator</h3>
            </>
          ) : (
            <>
              <h3 style={{display:"block"}}>
                <svg xmlns="http://w3.org" width="1em" height="1em" fill="none" stroke="green" stroke-width="3" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" style={{verticalAlign:"-0.1em", marginRight:"0.2em"}}>
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Verified accident free vehicle
              </h3>
            </>
          )}
        </div>
        <div className="diagram-spacer" />
      </div>
      <div className="report-map-mobile">
        <div className="diagram-column">
          <img className="report-map-img" src={accidentMap} alt="Mapping" />
          { locations.map((location, index) => (
            <div key={index} className="diagram-marker" style={{top:`${location.y*100}%`, left:`${location.x*100}%`}}/>
          ))}
        </div>
        <hr />
        <div className="diagram-column">
          {(locations.length > 0) ? (
            <>
              <div className="diagram-marker" style={{top:'50%', left:'0%'}}/>
              <h3>Damage/Repair Indicator</h3>
            </>
          ) : (
            <>
              <h3 style={{display:"block"}}>
                <svg xmlns="http://w3.org" width="1em" height="1em" fill="none" stroke="green" strokeWidth="3" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" style={{verticalAlign:"-0.1em", marginRight:"0.2em"}}>
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Verified accident free vehicle
              </h3>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

